/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_QuarterInputs */

const vi_report_preset_quarter = /** @type {(inputs: Report_Preset_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quý này`)
};

/**

* @param {Report_Preset_QuarterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_quarter = /** @type {((inputs?: Report_Preset_QuarterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_QuarterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_quarter(inputs)
});